import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { OpportunityV2 } from 'models'

const FLOW_TYPE_KEY = 'opportunityFlowType'

const initialState: OpportunityV2 = {
  flowType: (localStorage.getItem(FLOW_TYPE_KEY) as 'online' | 'offline' | null) || undefined,
}

const opportunitySlice = createSlice({
  name: 'opportunity',
  initialState,
  reducers: {
    updateOpportunityInfo: (state: OpportunityV2, action: PayloadAction<OpportunityV2>) => {
      const { payload } = action
      return {
        ...state,
        ...payload,
      }
    },
    setFlowType: (state: OpportunityV2, action: PayloadAction<'online' | 'offline'>) => {
      state.flowType = action.payload
      localStorage.setItem(FLOW_TYPE_KEY, action.payload)
    },
    clear: () => {
      localStorage.removeItem(FLOW_TYPE_KEY)
      return { flowType: undefined }
    },
  },
})

export const { updateOpportunityInfo, setFlowType, clear } = opportunitySlice.actions

export default opportunitySlice.reducer
